/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tr_Title_TranslatedInputs */

const en_tr_title_translated = /** @type {(inputs: Tr_Title_TranslatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`translated`)
};

const de_tr_title_translated = /** @type {(inputs: Tr_Title_TranslatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`übersetzt`)
};

/**
* | output |
* | --- |
* | "translated" |
*
* @param {Tr_Title_TranslatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tr_title_translated = /** @type {((inputs?: Tr_Title_TranslatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tr_Title_TranslatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tr_title_translated(inputs)
	return en_tr_title_translated(inputs)
});